import { render, staticRenderFns } from "./AulasInstrutorModal.vue?vue&type=template&id=54bccd6a&scoped=true"
import script from "./AulasInstrutorModal.vue?vue&type=script&lang=js"
export * from "./AulasInstrutorModal.vue?vue&type=script&lang=js"
import style0 from "./AulasInstrutorModal.vue?vue&type=style&index=0&id=54bccd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bccd6a",
  null
  
)

export default component.exports